import { jsxs as _, jsx as m } from "react/jsx-runtime";
import { useRef as K, useState as N, useEffect as w, useMemo as C, useCallback as E, useLayoutEffect as F } from "react";
import H from "classnames";
import d from "./index.es812.js";
import { useOnKeyPress as g } from "@placer-ui/hooks";
import { ChipContent as M } from "./index.es813.js";
import { ChipActions as R } from "./index.es814.js";
const U = "chip-component", b = ({
  size: y = "small",
  label: r,
  LeftIcon: k,
  ColorIndicator: V,
  testId: j = U,
  isSelected: I,
  allowSelection: i = !1,
  onGoto: a,
  onEdit: o,
  onDelete: s,
  onClick: c
}) => {
  const h = K(null), u = K(null), [v, B] = N("fit-content"), [W, A] = N(!1);
  w(() => {
    i && A(!!I);
  }, [i, I]);
  const p = C(() => {
    let t = 0;
    return o && t++, a && t++, s && t++, t;
  }, [s, o, a]), e = p > 0, L = H(d.chip, d[`size-${y}`], {
    [d.selected]: W
  }), O = C(() => ({
    width: v,
    "--actions-count": p
  }), [p, v]), T = E(
    (t) => {
      c == null || c(t), i && A((f) => !f);
    },
    [i, c]
  ), P = C(() => {
    const t = [];
    return a && t.push({ actionVariant: "goto", onClick: () => a(r) }), o && t.push({ actionVariant: "edit", onClick: () => o(r) }), s && t.push({ actionVariant: "close", onClick: () => s(r) }), t;
  }, [r, s, o, a]);
  F(() => {
    const t = () => {
      if (!(u != null && u.current) || !p) return;
      const x = u.current.getBoundingClientRect().width + 2;
      x > 0 && B(x);
    };
    t();
    const f = setTimeout(t, 0);
    return () => clearTimeout(f);
  }, [p]), g("Delete", () => s == null ? void 0 : s(r), h.current), g("Backspace", () => s == null ? void 0 : s(r), h.current);
  const n = c || i;
  return /* @__PURE__ */ _(
    "div",
    {
      ref: h,
      className: L,
      style: O,
      "data-testid": j,
      tabIndex: n && !e ? 0 : -1,
      "data-identifier": "chip",
      role: n && !e ? "button" : void 0,
      "aria-pressed": n && !e && i ? W : void 0,
      onKeyDown: n && !e ? (t) => {
        n && (t.key === "Enter" || t.key === " ") && (t.preventDefault(), T(r));
      } : void 0,
      onClick: n ? () => T(r) : void 0,
      children: [
        /* @__PURE__ */ m(
          M,
          {
            ref: u,
            label: r,
            LeftIcon: k,
            ColorIndicator: V,
            size: y,
            isClickable: !!c
          }
        ),
        e && /* @__PURE__ */ m("span", { className: d.chipActions, children: /* @__PURE__ */ m(R, { actions: P }) })
      ]
    }
  );
};
export {
  U as CHIP_DEFAULT_TESTID,
  b as Chip
};
//# sourceMappingURL=index.es34.js.map
